module.exports = __webpack_public_path__ + "static/16-sault-25ae5fb232f032249f99ceda92606f24.jpg";